import React from 'react';
import * as icons from 'assets/icons/index';

export type IconName = keyof typeof icons;
type ObjectName = 'doctorSearchResults' | 'doctorsSearch' | 'medicalCenterSearchResults' | 'medicineSearchResults' | 'zakautSearchResults' | 'outerServicesSearchResults' | 'operationsSearchResults';
function SvgGenerator(props: { name: IconName, className?: string, objectName: ObjectName, fallBackIcon?: IconName, title?: string }) {
  const iconsObjects: Record<ObjectName, any> = {
    doctorSearchResults: window.ICONS_doctorSearchResults,
    doctorsSearch: window.ICONS_doctorsSearch,
    medicalCenterSearchResults: window.ICONS_medicalCenterSearchResults,
    medicineSearchResults: window.ICONS_medicineSearchResults,
    zakautSearchResults: window.ICONS_zakautSearchResults,
    outerServicesSearchResults: window.ICONS_outerServicesSearchResults,
    operationsSearchResults: window.ICONS_OperationsSearchResults
  }
  const { name, className, objectName, title } = props;
  if (typeof name === 'string' && iconsObjects[objectName]?.hasOwnProperty(name)) {
    return <img src={(iconsObjects[objectName] as any)[name]} className={className} aria-label={title} />
  } else {
    const Icon = icons[props.fallBackIcon ? props.fallBackIcon : name];
    const Component = Icon as React.ElementType;
    return (
      <Component className={className} title={title} aria-label={title} />
    );
  }
}
export default SvgGenerator